import React from 'react';
import {
  sumImpressions, countLineItems, flightDaysInclusive, campaignFlightStr, planTerms,
} from './planSelectors';
import './CampaignSummary.css';

const fmtImp = (n) => (n || 0).toLocaleString();

const CampaignSummary = ({ plan }) => {
  const impressions = sumImpressions(plan);
  const flight = campaignFlightStr(plan);
  const days = flightDaysInclusive(plan);
  const lineItemCount = countLineItems(plan);
  const dailyAvg = days > 0 ? Math.round(impressions / days) : 0;

  const advertiser = plan.advertiserName
    || plan.campaign?.advertiserName
    || '—';
  const name = plan.campaign?.displayName || '—';
  const platform = (plan.platform || '').toUpperCase();
  const terms = planTerms(plan);

  return (
    <div className="card campaign-summary">
      <div className="campaign-summary-head">
        <div>
          <div className="campaign-summary-name">{name}</div>
          <div className="campaign-summary-sub">
            {advertiser} · {platform}
          </div>
        </div>
        <div className="campaign-summary-flight">
          {flight}
          {days > 0 && <span className="campaign-summary-days"> ({days} days)</span>}
        </div>
      </div>
      <div className="campaign-summary-metrics">
        <div className="cs-metric">
          <div className="cs-metric-label">Impressions</div>
          <div className="cs-metric-value">{fmtImp(impressions)}</div>
        </div>
        <div className="cs-metric">
          <div className="cs-metric-label">Avg / Day</div>
          <div className="cs-metric-value">{fmtImp(dailyAvg)}</div>
        </div>
        <div className="cs-metric">
          <div className="cs-metric-label">{terms.ios}</div>
          <div className="cs-metric-value">{(plan.insertionOrders || []).length}</div>
        </div>
        <div className="cs-metric">
          <div className="cs-metric-label">{terms.lis}</div>
          <div className="cs-metric-value">{lineItemCount}</div>
        </div>
      </div>
    </div>
  );
};

export default CampaignSummary;
